<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
  title: String,
});

const tooltipRef = ref(null);

onMounted(() => {
  if (tooltipRef.value) {
    $(tooltipRef.value).tooltip({ boundary: "window" });
  }
});
</script>

<template>
  <span v-if="props.title" ref="tooltipRef" tabindex="0" data-toggle="tooltip" data-placement="top" :title="props.title">
    <slot>

    </slot>
  </span>
</template>

<style scoped>
</style>
